import Vue from 'vue'
//import Vuex from 'vuex'
import customer from './modules/customer'
import getters from './getters';

//Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    customer
  },
  getters,
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js